import { render, staticRenderFns } from "./StepFileUploads.vue?vue&type=template&id=638531be"
import script from "./StepFileUploads.vue?vue&type=script&lang=js"
export * from "./StepFileUploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports